import { useState, useRef, useEffect } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions/InstallationActions";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

export default function UniversalCalendar() {
    const calendarRef = useRef(null);
    const [view, setView] = useState("dayGridMonth");
    const dispatch = useDispatch();
    const eventList = useSelector((state) => state.installerListVehicleEvents);
    const [loading, setLoading] = useState(true);

    const handleBackButtonClick = () => {
        setView("dayGridMonth");
        calendarRef.current.getApi().changeView("dayGridMonth");
    };

    const handleEventClick = (info) => {
        if (window.confirm("Are you sure you want to delete this event?")) {
            dispatch(actions.InstallerListVehicleEventsDeleteEvent(info.event.extendedProps));
        }
    };

    useEffect(() => {
        dispatch(actions.InstallerListVehicleEventsUpdate());
        setLoading(false);
    }, [dispatch]);

    return (
        <div>
            <AuthenticatedTemplate>
                <div className={"title-container"}>
                    <h1>Installers Calendar</h1>
                </div>
                <div className="page-container">
                    <div className="page-section">
                     
                        {view === "timeGridDay" && (
                            <div className="container installer-header calendar-header">
                                <button className="btn btn-secondary back-button" onClick={handleBackButtonClick}>
                                    <span className="back-button-arrow"></span> Back
                                </button>
                            </div>   
                        )}
                        <div className="calendar-container">
                            {loading ? (
                                "loading calendar ...."
                            ) : (
                                <div className="calendar-wrapper">
                                    <FullCalendar
                                        ref={calendarRef}
                                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                        initialView={view}
                                        headerToolbar={{
                                            start: "prev today",
                                            center: "title",
                                            end: "dayGridMonth timeGridDay next",
                                        }}
                                        contentHeight="auto"
                                        businessHours={[
                                            {
                                                daysOfWeek: [1, 2, 3, 4, 5],
                                                startTime: "7:00",
                                                endTime: "16:00",
                                            },
                                            { daysOfWeek: [6], startTime: "7:00", endTime: "13:00" },
                                        ]}
                                        dateClick={(info) => {
                                            if (info.view.type === "dayGridMonth") {
                                                setView("timeGridDay");
                                                calendarRef.current.getApi().changeView("timeGridDay", info.dateStr);
                                            }
                                        }}
                                        select={() => { }}
                                        events={eventList}
                                        eventClick={handleEventClick}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <p>
                    You are trying to view the installation calendar while signed out. Please sign in to
                    continue.
                </p>
            </UnauthenticatedTemplate>
        </div>
    );
}
